/**
 * Created by Anam Farrukh on 10/15/2015
 */
(function () {
    angular.module('tmx-common')
        .factory('ServerExceptionService', function () {
            var Globalmessage = "";
            var watch_count = 0;

            return {
                Displayfunction: function(DisplayServerError){
                     
                    Globalmessage = DisplayServerError;
                    return DisplayServerError;
                },
                SetWatch: function(count){
                    watch_count = count;
                    return watch_count;
                },
                Displaymsg: Globalmessage,  //empty string for later use in controller to store the error message to
                // be displayed
                watch_count: watch_count

            };


        });

})();